import createReducer from "./reducerUtils";
import {
  LOGIN_USER,
  LOGOUT_USER,
  CURRENT_USER,
  LOADING_REFRESH_TOKEN,
  SHOW_DIALOG_USER_IDDLE,
  AUTHENTICATION_V2_USER
} from "../actions/actionTypes";

const initialState = {
  currentUser: null,
  loadingRefreshToken: false,
  showDialogUserIddle: false,
  authentication: null,
};

const loginUser = (state, payload) => {
  return {
    ...state,
    currentUser: payload.currentUser,
  };
};

const setCurrentUser = (state, payload) => {
  return {
    ...state,
    currentUser: payload.currentUser,
  };
};

const signOutUser = () => {
  return { currentUser: null, showDialogUserIddle: false };
};

const loadingRefreshToken = (state, payload) => {
  return { ...state, loadingRefreshToken: payload.loadingRefreshToken };
};

const showDialogUserIddle = (state, payload) => {
  return { ...state, showDialogUserIddle: payload.showDialogUserIddle };
};

const getAuthentication = (state, payload) => {
  return { ...state, authentication: payload.authentication};
}

export default createReducer(initialState, {
  [LOGIN_USER]: loginUser,
  [LOGOUT_USER]: signOutUser,
  [CURRENT_USER]: setCurrentUser,
  [LOADING_REFRESH_TOKEN]: loadingRefreshToken,
  [SHOW_DIALOG_USER_IDDLE]: showDialogUserIddle,
  [AUTHENTICATION_V2_USER]: getAuthentication,
});
